export default class Versions {

	constructor (data) {
		this.data = data
	}

	static async fetch () {

		let data = await Anvil.REST.get('/c_order/versions')
		return new Versions(data)
	}

	static colors = {
		'invalid': 'info',
		'deprecated': 'primary',
		'stable': 'success',
		'beta': 'warning',
		'alpha': 'danger',
		'unpublished': 'black',
		'indeterminate': 'secondary'
	}

	verstate(version) {
		if (!Anvil.versions.validate(version)) {
			return 'invalid'
		}
		if (this.data) {
			if (Anvil.versions.compare(version, this.data.stable.version, '<')) {
				return 'deprecated'
			}
			if (Anvil.versions.compare(version, this.data.stable.version, '=')) {
				return 'stable'
			}
			if (Anvil.versions.compare(version, this.data.beta.version, '<=')) {
				return 'beta'
			}
			if (Anvil.versions.compare(version, this.data.alpha.version, '<=')) {
				return 'alpha'
			}
			return 'unpublished'
		}
		return 'indeterminate'
	}
}
